import dynamic from 'next/dynamic'
import { IconExpandMoreDefault } from '@mc/design-system'
import { usePrimaryCta } from '@mc/growth'
import { useTranslation } from '@mc/i18n'
import { EventTypes, Locations, track } from '@mc/track-event'
import CTA from 'components/CTA'

const InstructorTiles = dynamic(() => import('./InstructorTiles'), {
  ssr: false,
})

export const InstructorTilesHero = () => {
  const { t } = useTranslation('@mc/next')
  const { ctaHref } = usePrimaryCta()

  return (
    <div className='container mc-mt-8 mc-text--center'>
      <h2 className='mc-text-h1 mc-mb-2'>
        {t('articles.instructorTiles.title')}
      </h2>
      <div className='row d-flex justify-content-center'>
        <div className='col-12 col-md-8'>
          <p className='mc-mb-8 mc-opacity--hinted'>
            {t('articles.instructorTiles.subtitle')}
          </p>
        </div>
      </div>
      <InstructorTiles />
      <div className='mc-my-8'>
        <CTA
          onClick={() => {
            track(EventTypes.ARTICLES_HOMEPAGE_CLICK, {
              location: Locations.AAP_UPSELL,
              href: ctaHref,
            })
          }}
        />
      </div>

      <div className='mc-pb-4 d-flex justify-content-center align-items-center'>
        <p className='mc-text-x-small mc-mr-3'>
          {t('articles.instructorTiles.scrollToRead')}
        </p>
        <IconExpandMoreDefault className='mc-text-h8' />
      </div>
    </div>
  )
}
